/**
 * CancelSection - Cancel button with optional create copy checkbox
 * 
 * @param {Object} props
 * @param {function} props.onCancel - Cancel handler
 * @param {boolean} props.showCreateCopyCheckbox - Show create copy checkbox
 * @param {boolean} props.createCopy - Create copy checkbox value
 * @param {function} props.onCreateCopyChange - Create copy change handler
 * @param {string} props.cancelButtonMarginTop - Custom marginTop for cancel button
 */
const CancelSection = ({
  onCancel,
  showCreateCopyCheckbox,
  createCopy,
  onCreateCopyChange,
  cancelButtonMarginTop,
}) => {
  return (
    <div style={{ display: "flex", alignItems: "center", marginTop: "10px" }}>
      <button
        className="appbar-button-secondary"
        onClick={onCancel}
        style={{
          backgroundColor: "#f1f3f4",
          color: "#47515c",
          border: "none",
          padding: "8px 12px",
          cursor: "pointer",
          borderRadius: "4px",
          marginLeft: "15px",
          marginRight: "15px",
          marginTop: cancelButtonMarginTop,
        }}
      >
        Cancel
      </button>

      {showCreateCopyCheckbox && (
        <label
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            cursor: "pointer",
            marginTop: "7px",
            marginLeft: "10px",
          }}
        >
          <input
            type="checkbox"
            checked={createCopy}
            onChange={onCreateCopyChange}
            style={{ width: "14px", height: "14px" }}
          />
          <span style={{ fontSize: "14px", fontWeight: "normal" }}>
            Create a Copy
          </span>
        </label>
      )}
    </div>
  );
};

export default CancelSection;

